import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagContratoResponse } from '../../responses/servico/get-tag-contrato.response';
import { CreateTagContratoResponse } from '../../responses/servico/create-tag-contrato.response';
import { TagRequest } from '../../requests/servico/tag.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class TagContratoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'TagContrato';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(
    descricao: string = '',
    pagina: number = 0,
    tamanhoPagina: number = 20
  ): Observable<GetTagContratoResponse> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (descricao) {
      params = params.set('descricao', descricao);
    }

    return this.httpClient
      .get<GetTagContratoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<CreateTagContratoResponse> {
    const url = `${this.apiUrl}/idTagContrato/${id}`;
    return this.httpClient
      .get<CreateTagContratoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public create(request: TagRequest): Observable<CreateTagContratoResponse> {
    return this.httpClient
      .post<CreateTagContratoResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(id: number, request: TagRequest): Observable<CreateTagContratoResponse> {
    const url = `${this.apiUrl}/idTagContrato/${id}`;
    return this.httpClient
      .put<CreateTagContratoResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteBulk(ids: number[]): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/bulk-delete`;
    return this.httpClient
      .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
